import { Separator } from '#app/components/ui/separator'
import { Logo } from './logo'

export function Footer() {
	return (
		<footer className="bg-gray-900 py-8 text-gray-300 sm:py-12">
			<div className="mx-auto max-w-6xl px-6">
				<div className="flex flex-col items-center gap-6">
					<div className="flex items-center gap-4">
						<Logo size="md" />
						<div className="flex flex-col">
							<span className="font-bold text-white">Task Sentry</span>
							<span className="text-xs text-gray-400">
								Privacy-First AI Focus
							</span>
						</div>
					</div>

					<Separator className="bg-gray-700" />

					<a
						href="https://www.producthunt.com/products/task-sentry?embed=true&utm_source=badge-task-sentry&utm_medium=badge"
						target="_blank"
						rel="noopener noreferrer"
						className="transition-opacity hover:opacity-80"
					>
						<img
							src="https://api.producthunt.com/widgets/embed-image/v1/featured.svg?post_id=1032826&theme=light&t=1761886649684"
							alt="Task Sentry - Stop getting distracted. Start getting things done. | Product Hunt"
							width="250"
							height="54"
							className="h-[54px] w-[250px]"
						/>
					</a>

					<div className="text-center">
						<p className="text-sm">
							&copy; 2025 Task Sentry. AI-powered focus protection, completely
							private.
						</p>
						<p className="mt-2 text-xs text-gray-400">
							Your data stays on your device. Always.
						</p>
					</div>
				</div>
			</div>
		</footer>
	)
}
